<template>
  <div class="av-document-and-signature-disclamer-container">
    <div class="m-48 text-left d-flex flex-column pw-height-100 ">
      <div class="form-check checkbox-new path" v-for="(disclamer, index) in currentDisclaimers" :key="index">
        <input @change="onDisclamerChange(disclamer)" v-model="disclamer.value" type="checkbox" class="form-check-input" id="exampleCheck1" />
        <svg viewBox="0 0 21 21">
          <path d="M5,10.75 L8.5,14.25 L19.4,2.3 C18.8333333,1.43333333 18.0333333,1 17,1 L4,1 C2.35,1 1,2.35 1,4 L1,17 C1,18.65 2.35,20 4,20 L17,20 C18.65,20 20,18.65 20,17 L20,7.99769186"></path>
        </svg>
        <label class="form-check-label" v-html="disclamer.disclaimer"></label>
        <span v-if="disclamer.required" class="desclaimer-asterics-label">
          <i class="fa fa-asterisk asterickStyle fs-7 desclaimer-asterics" aria-hidden="true"></i>
        </span>
      </div>
      <div class="row pt-30 agree-btn-group mt-auto">
        <div class="col-6 col-md-6 pl-0">
          <button data-dismiss="modal" data-toggle="modal" @click="$emit('disagree')" v-translate:rsb_disagree="lang" class="btn leavestudy">
            Disagree
          </button>
        </div>
        <div class="col-6 col-md-6 pr-0 discard-btn">
          <button data-dismiss="modal" data-toggle="modal" @click="onDisclamerSubmit" :disabled="isDocumentDisclamerRequired" v-translate:rsb_agree="lang" class="btn leave_study_cntue primary-bg">
            Agree
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { v4 as uuidv4 } from "uuid";
import moment from "moment";
import { mapGetters } from "vuex";
export default {
  props: ["disclaimers", "newSignedDocs"],
  data() {
    return {
      currentDisclaimers: this.disclaimers
    };
  },
  watch: {
    disclaimers(val) {
      this.currentDisclaimers = val;
    }
  },
  computed: {
    lang() {
      const selectedLanguage = this.$store.getters.getParticipantsPortalLanguages;
      return selectedLanguage ? selectedLanguage.language_culture : "en";
    },
    ...mapGetters({
      participant: "participant"
    }),
    getParticipantDetails() {
      return JSON.parse(JSON.stringify(this.participant));
    },
    isDocumentDisclamerRequired() {
      return this.currentDisclaimers.reduce((status, item) => {
        if (status) {
          return true;
        }
        if (item.required && !item.value) {
          return true;
        } else {
          return false;
        }
      }, false);
    }
  },
  methods: {
    onDisclamerSubmit() {
      this.$emit("onSignDoc", this.currentDisclaimers.map(this.onDisclamerChange));
    },
    onDisclamerChange(disclamer) {
      const now = new Date();
      const { studyId, disclaimerId, disclaimer, required } = disclamer;
      const { languageId, pid, siteId, languageName } = this.participant;
      let disclamerPayload = {
        deviceId: uuidv4(),
        disclaimerContent: disclaimer,
        disclaimerId: disclaimerId,
        displayDisclaimerContent: disclaimer,
        displayLanguage: languageName,
        isDisclaimerRequired: required,
        languageId: languageId,
        participantId: pid,
        siteId: siteId,
        studyId: studyId,
        disclaimerCheckedOnLocal: moment(now).format("YYYY-MM-DD HH:mm:ss"),
        disclaimerCheckedOnOffset: moment(now).format("Z")
      };
      if (required) {
        disclamerPayload = {
          ...disclamerPayload,
          value: disclamer.value
        };
      }
      if (disclamer.value) {
        this.newSignedDocs.consentDisclaimer.push(disclamerPayload);
      } else {
        if (this.newSignedDocs.consentDisclaimer && this.newSignedDocs.consentDisclaimer.length && !disclamer.value) {
          const removeIndex = this.newSignedDocs.consentDisclaimer.findIndex(item => item.disclaimerId === disclamer.disclaimerId);
          this.newSignedDocs.consentDisclaimer.splice(removeIndex, 1);
        }
      }
      return disclamerPayload;
    }
  }
};
</script>

<style lang="scss" scoped>
.av-document-and-signature-disclamer-container {
  .checkbox-new {
    --background: #fff;
    --border: #979797;
    --border-hover: #3b3b3b;
    --border-active: #48bf94;
    --tick: #48bf94;
    --required: #fb1b1b;
    position: relative;
  }
  .checkbox-new input,
  .checkbox-new svg {
    width: 16px;
    height: 16px;
  }
  .checkbox-new input {
    -webkit-appearance: none;
    -moz-appearance: none;
    position: relative;
    outline: none;
    background: var(--background);
    border: none;
    padding: 0;
    cursor: pointer;
    border-radius: 4px;
    transition: box-shadow 0.3s;
    box-shadow: inset 0 0 0 var(--s, 1px) var(--b, var(--border));
    top: 3px;
  }
  .checkbox-new input:hover {
    --s: 1px;
    --b: var(--border-hover);
  }
  .checkbox-new input:checked {
    --b: var(--border-active);
  }
  .checkbox-new svg {
    pointer-events: none;
    fill: none;
    stroke-width: 2px;
    stroke-linecap: round;
    stroke-linejoin: round;
    stroke: var(--stroke, var(--border-active));
    position: absolute;
    top: 9px;
    left: 1px;
    width: 16px;
    height: 16px;
    transform: scale(var(--scale, 1)) translateZ(0);
  }
  .checkbox-new.path input:checked {
    --s: 2px;
    transition-delay: 0.4s;
  }
  .checkbox-new.path input:checked + svg {
    --a: 16.1 86.12;
    --o: 102.22;
  }
  .checkbox-new.path svg {
    stroke-dasharray: var(--a, 86.12);
    stroke-dashoffset: var(--o, 86.12);
    transition: stroke-dasharray 0.6s, stroke-dashoffset 0.6s;
  }
  .checkbox-new.bounce {
    --stroke: var(--tick);
  }
  .checkbox-new.bounce input:checked {
    --s: 11px;
  }
  .checkbox-new.bounce input:checked + svg {
    animation: bounce 0.4s linear forwards 0.2s;
  }
  .checkbox-new.bounce svg {
    --scale: 0;
  }
  .checkbox-new .form-check-label {
    position: relative;
    top: 5px;
    left: 2px;
  }
  @keyframes bounce {
    50% {
      transform: scale(1.2);
    }
    75% {
      transform: scale(0.9);
    }
    100% {
      transform: scale(1);
    }
  }
  .desclaimer-asterics-label {
    position: absolute;
  }
  .desclaimer-asterics {
    position: absolute;
    top: 4px;
    right: -10px;
  }
  .checkbox-new .form-check-input.required-input {
    -webkit-box-shadow: inset 0 0 0 var(--s, 1px) var(--b, var(--required));
    box-shadow: inset 0 0 0 var(--s, 1px) var(--b, var(--required));
  }
  #exampleCheck1 {
    position: absolute;
  }
}
</style>
